import { Trans } from 'react-i18next'

import { BuilderComponentSettingValue, BuilderMenu } from '@makyoapp/makyo-common'
import { Menu16, Screen24 } from '@makyoapp/makyo-icon/icon'
import { SelectDropdown } from '@makyoapp/makyo-ui'

import { cn } from '@/lib/cn'
import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { useVariableTextSingleCell } from '@/hooks/__project__/useVariableTextSingleCell'
import { useUpdateCompSettingValue } from '@/hooks/useUpdateCompSettings'
import { BuilderComponentSetting } from '@/shared/builder'
import { SHOW_SEARCH_LIMIT } from '@/shared/constants'

const RenderMenuOption = ({ menu }: { menu: BuilderMenu }) => {
  const menuTitle = useVariableTextSingleCell(menu.title)
  return (
    <div className={cn('flex-c', menu.id ? '' : 'text-light')}>
      {menu.id === '[screen]' ? <Screen24 /> : <Menu16 />}
      <div>{menuTitle}</div>
    </div>
  )
}

const MenuSelectFieldSetting = ({
  id,
  settingId,
  value,
  menuSelectSettings,
}: {
  id: string
  settingId: string
  value: any
  menuSelectSettings: BuilderComponentSetting['menuSelectSettings']
}) => {
  const { menus } = useAppBuilderContext()

  const updateValue = useUpdateCompSettingValue(id)

  const { multiple = false } = menuSelectSettings ?? {}
  const valueArray = value as BuilderComponentSettingValue[]
  const isArr = Array.isArray(value)

  const menuOptions = [{ id: '[screen]', title: 'Screens' } as BuilderMenu, ...menus]

  const handleChange = async (menu: BuilderMenu | BuilderMenu[]) => {
    await updateValue(
      multiple
        ? Array.isArray(menu)
          ? menu.map(({ id }) => id)
          : []
        : // @ts-ignore
          menu.id === ''
          ? undefined
          : // @ts-ignore
            menu.id
    )
  }

  return (
    <SelectDropdown
      withSearch={menus.length > SHOW_SEARCH_LIMIT}
      multiple={multiple}
      placeholder={<Trans>Select Menu or Screen</Trans>}
      value={
        multiple
          ? isArr
            ? menuOptions.filter(({ id }) => {
                valueArray.includes(id)
              })
            : []
          : menuOptions.find(({ id }) => id === value)
      }
      onChange={handleChange}
      // @ts-ignore
      optionLabel={(opt) => `${opt?.id} ${opt?.title}`}
      options={multiple ? menuOptions : [{ id: '', title: 'Select Menu' } as BuilderMenu, ...menuOptions]}
      renderOption={(opt) => <RenderMenuOption menu={opt as BuilderMenu} />}
    />
  )
}

export default MenuSelectFieldSetting
